export default "/images/mocis.svg?7635bfe7af68c569d321461dcc0bf74e";